<div
  class="container"
  fxLayout="row wrap"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
  matomoForm="incoming-request-to-pay"
>
  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYER_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="payerPartyId"
      matomoClick="rtp-filter-payer-id"
      (focus)="onFilterUsed('Payer ID')"
      (blur)="onFilterUsed('Payer ID', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.EXTERNAL_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="externalId"
      matomoClick="rtp-filter-external-id"
      (focus)="onFilterUsed('External ID')"
      (blur)="onFilterUsed('External ID', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{
      "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate
    }}</mat-label>
    <mat-select
      [formControl]="payerDfspId"
      matomoClick="rtp-filter-ams-code"
      (focus)="onFilterUsed('AMS Business Code')"
      (selectionChange)="onFilterUsed('AMS Business Code', $event.value)"
    >
      <mat-option
        *ngFor="let code of amsCodes"
        [value]="code.value"
        matomoClick="rtp-ams-code-option-{{ code.value }}"
      >
        {{ code.option }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYEE_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="payeePartyId"
      matomoClick="rtp-filter-payee-id"
      (focus)="onFilterUsed('Payee ID')"
      (blur)="onFilterUsed('Payee ID', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.TRANSACTION_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="transactionId"
      matomoClick="rtp-filter-transaction-id"
      (focus)="onFilterUsed('Transaction ID')"
      (blur)="onFilterUsed('Transaction ID', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.STATUS" | translate }}</mat-label>
    <mat-select
      [formControl]="status"
      matomoClick="rtp-filter-status"
      (focus)="onFilterUsed('Status')"
      (selectionChange)="onFilterUsed('Status', $event.value)"
    >
      <mat-option [value]="" matomoClick="rtp-status-option-all"
        >--{{ "COMMON.SELECT_STATUS" | translate }}--</mat-option
      >
      <ng-container *ngFor="let filter of transactionStatusData">
        <mat-option
          [value]="filter.value"
          *ngIf="!filter.hidden"
          matomoClick="rtp-status-option-{{ filter.value }}"
        >
          {{ filter.option }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.AMOUNT" | translate }}</mat-label>
    <input
      matInput
      [formControl]="amount"
      matomoClick="rtp-filter-amount"
      (focus)="onFilterUsed('Amount')"
      (blur)="onFilterUsed('Amount', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>Currency</mat-label>
    <input
      matInput
      [formControl]="currencyCode"
      [matAutocomplete]="currenciesAutocomplete"
      matomoClick="rtp-filter-currency"
      (focus)="onFilterUsed('Currency')"
      (blur)="onFilterUsed('Currency', $event.target.value)"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>Transaction Date From</mat-label>
    <input
      matInput
      placeholder="yyyy-MM-dd hh:mm:ss"
      [ngxMatDatetimePicker]="picker"
      [formControl]="transactionDateFrom"
      [min]="minDate"
      [max]="maxDate"
      matomoClick="rtp-filter-date-from"
      (focus)="onFilterUsed('Transaction Date From'); onDatePickerUsed('from')"
      (dateChange)="onFilterUsed('Transaction Date From', $event.value)"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="picker"
      matomoClick="rtp-datepicker-from-toggle"
    >
    </mat-datepicker-toggle>
    <ngx-mat-datetime-picker #picker [showSeconds]="true">
    </ngx-mat-datetime-picker>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>Transaction Date To</mat-label>
    <input
      matInput
      placeholder="yyyy-MM-dd hh:mm:ss"
      [ngxMatDatetimePicker]="pickerTo"
      [formControl]="transactionDateTo"
      [min]="minDate"
      [max]="maxDate"
      matomoClick="rtp-filter-date-to"
      (focus)="onFilterUsed('Transaction Date To'); onDatePickerUsed('to')"
      (dateChange)="onFilterUsed('Transaction Date To', $event.value)"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerTo"
      matomoClick="rtp-datepicker-to-toggle"
    >
    </mat-datepicker-toggle>
    <ngx-mat-datetime-picker #pickerTo [showSeconds]="true">
    </ngx-mat-datetime-picker>
  </mat-form-field>
</div>

<!-- Autocomplete data -->
<mat-autocomplete
  autoActiveFirstOption
  #currenciesAutocomplete="matAutocomplete"
  [displayWith]="displayCurrencyName"
>
  <mat-option
    *ngFor="let currency of filteredCurrencies | async"
    [value]="{
      AlphabeticCode: currency.AlphabeticCode,
      Currency: currency.Currency
    }"
    matomoClick="rtp-currency-option-{{ currency.AlphabeticCode }}"
    (click)="onAutocompleteSelection('Currency', currency.AlphabeticCode)"
  >
    {{ currency.Currency }} ( {{ currency.AlphabeticCode }} )
  </mat-option>
</mat-autocomplete>

<div class="container">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="startedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Start Time (UTC)
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ formatDate(convertTimestampToUTCDate(requestToPay.startedAt)) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="completedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Completed Time (UTC)
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ formatDate(convertTimestampToUTCDate(requestToPay.completedAt)) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="transactionId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Transaction ID
        </th>
        <td
          mat-cell
          *matCellDef="let requestToPay"
          matTooltip="{{ requestToPay.transactionId }}"
        >
          {{ shortenValue(requestToPay.transactionId) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerPartyId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Payer Party ID
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payerPartyId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payeePartyId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Payee Party ID
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payeePartyId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerDfspId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          AMS Business Short Code
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.payerDfspId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerDfspName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Payer DFSP Name
        </th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ displayDfspName(getDfpsEntry(requestToPay.payerDfspId)) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.amount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
        <td mat-cell *matCellDef="let requestToPay">
          {{ requestToPay.currency }}
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
        <td
          mat-cell
          *matCellDef="let requestToPay"
          [ngClass]="{
            red: requestToPay.state === 'FAILED',
            green: requestToPay.state === 'ACCEPTED',
            orange: requestToPay.state === 'IN_PROGRESS',
            blue: requestToPay.state === 'NOT_AUTOSAVED'
          }"
        >
          {{ requestToPay.state }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="[row.workflowInstanceKey]"
        class="select-row"
      ></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.records$ | async"
      #paginator
      [pageSizeOptions]="[10, 20, 30]"
      showFirstLastButtons
      [showFirstLastButtons]="true"
      [pageIndex]="0"
    >
    </mat-paginator>
  </div>
  <form
    #postForm="ngForm"
    (ngSubmit)="exportCSV(postForm.value)"
    class="csv-form"
  >
    <div
      class="container-fluid"
      fxLayout="row wrap"
      fxLayoutGap="2%"
      fxLayout.lt-md="column"
    >
      <mat-form-field fxFlex="20%">
        <mat-label for="querytype" class="form-control">Filter By</mat-label>
        <select
          id="querytype"
          name="cars"
          class="form-control"
          required
          ngModel
          matNativeControl
        >
          <option value="transactionid">TRANSACTION ID</option>
          <option value="payerid">PAYER ID</option>
          <option value="payeeid">PAYEE ID</option>
          <option value="externalid">EXTERNALID</option>
          <option value="workflowinstancekey">WORKFLOWINSTANCEKEY</option>
          <option value="payerdfspid">AMS Business Short Code</option>
        </select>
      </mat-form-field>
      <mat-form-field class="example-full-width form-group" fxFlex="20%">
        <mat-label for="querytype" class="form-control">Value</mat-label>
        <input
          matInput
          type="text"
          class="form-control col-sm-4"
          id="filterBy"
          required
          ngModel
          name="val"
          placeholder="comma-separated-list"
        />
      </mat-form-field>
    </div>

    <button mat-stroked-button type="submit" [disabled]="!postForm.valid">
      Export CSV
    </button>
  </form>
</div>
